/* eslint-disable react/self-closing-comp */
import React from 'react'

import {
  creditsRoute,
  friendsRoute,
  homeRoute,
  historyRoute,
  profileRoute,
  contactUsRoute
} from '../routes/routes'

const data = {
  sideNavMenu: [
    {
      text: 'Home',
      icon: <i className="icon-home" />,
      link: homeRoute.path
    },
    {
      text: 'Profile',
      icon: <i className="icon-user" />,
      link: profileRoute.path
    },
    {
      text: 'Credits',
      icon: <i className="icon-credit-card" />,
      link: creditsRoute.path
    },
    {
      text: 'Contact Us',
      icon: <i className="icon-phone" />,
      link: contactUsRoute.path
    }
  ],
  headerMenu: [
    {
      text: 'Profile',
      link: profileRoute.path
    },
    {
      text: 'Order History',
      link: historyRoute.path
    },
    {
      text: 'Credits',
      link: creditsRoute.path
    },
    {
      text: 'Friends',
      link: friendsRoute.path
    }
  ],
  simpleMenu: [
    {
      text: 'My Home',
      link: homeRoute.path
    }
  ]
}

export default data
